import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "./constants";
import api, { baseUrl } from "../services/api";

export const useProvinces = () => {
  const queryKey = [QueryKey.Provinces];

  const queryFn = async () => {
    const URL = `${baseUrl}/provinces`;

    const { data } = await api.get(URL);

    return data;
  };

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
  });
};
